module.exports = __webpack_public_path__ + "img/2.c0e693f1.jpg";